export const objectToCssString = (styles) => {
    return Object.entries(styles)
        .map(([key, value]) => `${key.replace(/[A-Z]/g, "-$&").toLowerCase()}: ${value}`)
        .join(";");
};
